<?php

\Core\View::$template = function () {

    $html = '';
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);
    $rqd = $pv['request_data']['data'];

    $html = '   
        <div class="container">
            <div class="row"> 
                <div class="col-sm-6 offset-sm-3 col-12" >
                     <div>
                        <h4>Edit Job #' . $rqd['id'] . '</h4>
                     </div>
                    <div class="row">
                        <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Job Title</label>
                                <input type="text" name="tilte" class="form-control" id="job_tilte" value="' . $rqd['title'] . '"/>
                            </div>
                        </div>
                       
                       <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Role Type</label>
                                <select id="role_type" name="role_type" class="form-control">
                                     <option value="Software engineer" ' . ($rqd['role_parent_id'] == "Software engineer" ? "selected" : "") . '>Software engineer</option>
                                     <option value="Designer" ' . ($rqd['role_parent_id'] == "Designer" ? "selected" : "") . '>Designer</option>
                                     <option value="Data scientist" ' . ($rqd['role_parent_id'] == "Data scientist" ? "selected" : "") . '>Data scientist</option>
                                     <option value="Product manager" ' . ($rqd['role_parent_id'] == "Product manager" ? "selected" : "") . '>Product manager</option>
                                     <option value="Marketer" ' . ($rqd['role_parent_id'] == "Marketer" ? "selected" : "") . '>Marketer</option>
                                     <option value="Recruiting" ' . ($rqd['role_parent_id'] == "Recruiting" ? "selected" : "") . '>Recruiting</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                                <div class="form-group">
                                    <label>Description</label>
                                    <textarea name="description" id="description" class="form-control" rows="10" cols="30">' . $rqd['description'] . '</textarea>
                                </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Level</label>
                                <select id="level" name="level" class="form-control">
                                     <option value="Senior" ' . ($rqd['job_level'] == "Senior" ? "selected" : "") . '>Senior</option>
                                     <option value="Mid" ' . ($rqd['job_level'] == "Mid" ? "selected" : "") . '>Mid</option>
                                     <option value="Junior" ' . ($rqd['job_level'] == "Junior" ? "selected" : "") . '>Junior</option>
                                 </select>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                            <div class="form-group">
                                <label>Type</label>
                               <select id="type" name="type" class="form-control">
                                    <option value="Full Time" ' . ($rqd['job_type'] == "Full Time" ? "selected" : "") . '>Full Time</option>
                                    <option value="Contractor" ' . ($rqd['job_type'] == "Contractor" ? "selected" : "") . '>Contractor</option>
                               </select>
                            </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                                <div class="form-group">
                                    <label>Location</label>
                                    <input type="text" name="location" class="form-control" id="location" value="' . $rqd['job_location'] . '"/>
                                </div>
                        </div>
                        
                        <div class="col-sm-12 col-12">
                                <div class="form-group">
                                    <label>Contact Person</label>
                                    <input type="text" name="contact_person" class="form-control" id="contact_person" value="' . $rqd['contact_person'] . '"/>
                                </div>
                        </div>
                        
                        <input type="hidden" value="' . $rqd['id'] . '" id="job_id">
                
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <span id="post_edit_job" class="btn btn-success">Save</span>
                                <span id="go-jobs-list" class="btn btn-warning">Job List</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>';

    return $html;

};





// WEBPACK FOOTER //
// app/JobList/View/JobEditPost.php